import React from 'react'
import { CircularProgress, Grid, TextField } from '@material-ui/core'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import { getLabelEndereco } from 'helpers/labels'
import { ModalConfirmacao } from 'components'

export const ModalVincularObjeto = (props) => {
  const {
    aberto,
    onClose,
    onConfirm,
    processando,
    carregandoObjetos,
    listaObjetosDoCaso,
    objetoSelecionado,
    setObjetoSelecionado
  } = props

  return (
    <ModalConfirmacao
      aberto={aberto}
      onClose={onClose}
      onConfirm={onConfirm}
      processando={processando}
      disabled={!objetoSelecionado}
      titulo="Selecione o objeto do caso que deseja vincular"
      confirmarLabel="Confirmar"
      maxWidth="sm"
    >
      <div style={{ width: '100%', marginTop: '10px' }}>
        {carregandoObjetos ? (
          <Grid container justifyContent="center" style={{ padding: '20px' }}>
            <CircularProgress size={24} />
          </Grid>
        ) : (
          <Grid item xs={12}>
            <AutocompleteNative
              name="objetosSelecionados"
              value={objetoSelecionado || null}
              noOptionsText="Sem informações"
              options={listaObjetosDoCaso || []}
              onChange={(event, newValue) => setObjetoSelecionado(newValue)}
              disabled={!listaObjetosDoCaso}
              required
              getOptionLabel={(option) => {
                if (option.flag === 'VESTIGIO') {
                  const texto = `VESTÍGIO ${option.identificador} - ${option.descricao?.toUpperCase() || ''}`
                  return texto.length > 50 ? texto.slice(0, 50) + '...' : texto
                }
                if (option.flag === 'CADAVER') return `CADÁVER - NIC: ${option.nic || ''}`
                if (option.flag === 'VEICULO') return `VEÍCULO - PLACA: ${option.placa || ''} | IDENTIFICADOR: ${option.identificador || ''}`
                if (option.flag === 'LOCAL') return `LOCAL - ENDEREÇO: ${getLabelEndereco(option)?.toUpperCase() || ''}`
                if (option.flag === 'PERICIANDO')
                  return `PERICIANDO - CPF: ${option.cpf || 'NÃO INFORMADO'} - ${option.nome ? `NOME: ${option.nome}` : `ALCUNHA: ${option.alcunha}` || 'NÃO INFORMADO'}`
                return ''
              }}
              renderOption={(option) => {
                if (option.flag === 'VESTIGIO') {
                  const texto = `VESTÍGIO ${option.identificador} - ${option.descricao?.toUpperCase() || ''}`
                  return texto.length > 50 ? texto.slice(0, 50) + '...' : texto
                }
                if (option.flag === 'CADAVER') return `CADÁVER - NIC: ${option.nic || ''}`
                if (option.flag === 'VEICULO') return `VEÍCULO - PLACA: ${option.placa || ''} | IDENTIFICADOR: ${option.identificador || ''}`
                if (option.flag === 'LOCAL') return `LOCAL - ENDEREÇO: ${getLabelEndereco(option)?.toUpperCase() || ''}`
                if (option.flag === 'PERICIANDO')
                  return `PERICIANDO - CPF: ${option.cpf || 'NÃO INFORMADO'} - ${option.nome ? `NOME: ${option.nome}` : `ALCUNHA: ${option.alcunha}` || 'NÃO INFORMADO'}`
                return ''
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="LISTA DOS OBJETOS QUE PODEM SER EXAMINADOS POR ESSE TIPO DE EXAME"
                  InputLabelProps={{ shrink: true }}
                />
              )}
            />
          </Grid>
        )}
      </div>
    </ModalConfirmacao>
  )
}
